import { render } from "./ModalContainer.vue?vue&type=template&id=cd0a4624"
import script from "./ModalContainer.vue?vue&type=script&lang=js"
export * from "./ModalContainer.vue?vue&type=script&lang=js"
script.render = render

export default script